export default __webpack_public_path__ + "static/media/bell-icon.48e8ea18.svg";